import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=add36416&scoped=true&"
import script from "./Modal_old.ts?vue&type=script&lang=ts&"
export * from "./Modal_old.ts?vue&type=script&lang=ts&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=add36416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add36416",
  null
  
)

component.options.__file = "Modal.vue"
export default component.exports